module.exports = __webpack_public_path__ + "img/Weapon_165.24d9cacb.png";